import type { FC } from 'react'

import dayjs from 'dayjs'

import { useAppContext } from '@/App.context'

import './footer.scss'

const Footer: FC = () => {
  const { whiteLabel } = useAppContext()

  return (
    <footer className={'wl-' + whiteLabel}>
      <span>© {dayjs().format('YYYY')} Skytech Control</span>
    </footer>
  )
}

export default Footer
